/**
 * Lightweight auth state — reads the JWT from localStorage and decodes
 * the payload. No library needed; we just base64-decode the middle segment.
 */

import { getToken, clearToken } from './api/client'

export interface AuthUser {
  tenantId: number
  userId: number
  role: string
}

function decodeJWT(token: string): AuthUser | null {
  try {
    const [, payload] = token.split('.')
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
    const claims = JSON.parse(json) as {
      tenant_id?: number
      user_id?: number
      role?: string
      exp?: number
    }
    // Check expiry
    if (claims.exp && claims.exp * 1000 < Date.now()) return null
    if (!claims.tenant_id || !claims.user_id) return null
    return {
      tenantId: claims.tenant_id,
      userId: claims.user_id,
      role: claims.role ?? 'viewer',
    }
  } catch {
    return null
  }
}

export function getAuthUser(): AuthUser | null {
  const token = getToken()
  if (!token) return null
  return decodeJWT(token)
}

export function logout(): void {
  clearToken()
  window.location.href = '/login'
}
